import Router from '@/router'
const state = {
	user: {
		accountId: null,
		address: "",
		contact: "",
		createdAt: null,
		mobile: "",
		name: "",
		phone: "",
		role: null,
		token: "",
		updatedAt: null,
		uuid: "",
		wx: "",
	},
	outTime: Date.now() + 1000 * 60 * 60 * 0.25,
	online: true
}

const mutations = {
	setUserInfo (state, payload) {
		state.user = {
			...state.user,
			...payload
		};
		state.online = payload.online
		// state.commit("userLog/saveUserLog", state.user)
	},
	creatTime (state) {
		state.outTime = Date.now() + 1000 * 60 * 60 * 0.25;
	},
	setOnline (state,online) {
		state.online =online;
	},
	logout (state) {
		state.user = {
			accountId: null,
			address: "",
			contact: "",
			createdAt: null,
			mobile: "",
			name: "",
			phone: "",
			role: null,
			token: "",
			updatedAt: null,
			uuid: "",
			wx: "",
		}
		Router.push({
			path: '/login', query: { redirect: Router.path }
		})
		window.clearVuexAlong();
	}

}
const actions = {
	setUserInfo ({ commit, state, dispatch }, params) {
		commit('setUserInfo', params);
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}